import React from 'react'
import { useFeiyongTypeDelMutation } from '../../../store/DianShangYeWuApi'
import Icon from '../../../cpn/Icon';
import { App } from 'antd'
function ExpenseTypeDel(props) {
    const {message} = App.useApp()
    const [submitDel] = useFeiyongTypeDelMutation()
    return (
        <Icon type='delete' 
            onClick={() => {
                submitDel({
                    fyt_id:props.fyt_id,
                }).then((res) => {
                    if (res.data.Status === 'success') {
                        message.info('删除成功');
                    }
                    if (res.data.Status === "fail") {
                        message.error('删除失败：'+res.data.Message)
                    }
                })
            }}
        > </Icon>
    )
    }

export default ExpenseTypeDel